/**
 * @file Table rows for the back orders list page.
 */



import React from "react";
import { TableCell, TableRow } from "@mui/material";
import DetailsButton from "../general/DetailsButton";
import { useNavigate } from "react-router-dom";



/**
 * Renders a list of deliveries as table rows,
 * each with a button that opens that delivery's back order detail page.
 *
 * Meant to be placed inside a table component that supplies the header and pagination.
 * This component only renders the rows.
 *
 * Each row shows, in order:
 * delivery number, delivery date, customer code, ship-to address name, order total (as "$" with 2 decimals),
 * discount percent (2 decimals with "%"), and a Details button.
 *
 * @param {Object} props
 * @param {Object[]} props.data - Deliveries from the `/backorders/` list endpoint.
 *                                Each needs `deliveryId`, `deliveryNumber`, `deliveryDate`,
 *                                `customerCode`, `shippingAddressName`, `orderTotal` and `discountPercent`.
 * @returns {JSX.Element} The table rows.
 */
function BackOrderList({ data }) {
  const navigate = useNavigate();

  /**
   * Navigates to the detail page for one delivery.
   *
   * @param {number} deliveryId - The delivery's internal ID (DocEntry).
   */
  const handleClick = (deliveryId) => {
    navigate("/backorders/" + deliveryId);
  };

  return (
    <React.Fragment>
      {data.map((backOrder) => (
        <TableRow key={backOrder.deliveryId} hover>
          <TableCell>{backOrder.deliveryNumber}</TableCell>
          <TableCell>{backOrder.deliveryDate}</TableCell>
          <TableCell>{backOrder.customerCode}</TableCell>
          <TableCell>{backOrder.shippingAddressName}</TableCell>
          <TableCell>{"$" + (backOrder.orderTotal * 1).toFixed(2)}</TableCell>
          <TableCell>{(backOrder.discountPercent * 1).toFixed(2) + "%"}</TableCell>
          <TableCell><DetailsButton onClick={() => handleClick(backOrder.deliveryId)} /></TableCell>
        </TableRow>
      ))}
    </React.Fragment>
  );
}

export default BackOrderList;